import {
  Banknote,
  Bell,
  Hash,
  Landmark,
  MessageCircle,
  SquarePen,
  Stamp,
  User,
  Wallet,
} from "lucide-react";
import type { NotificationCategory } from "../types";

type Props = {
  type: string;
  category?: NotificationCategory;
  isUnread: boolean;
};

const getCategory = (type: string): NotificationCategory => {
  const normalizedType = type.toLowerCase();

  if (
    normalizedType.includes("payment") ||
    normalizedType.includes("invoice")
  ) {
    return "payment";
  }
  if (
    normalizedType.includes("kyb") ||
    normalizedType.includes("company-verification")
  ) {
    return "kyb";
  }
  if (
    normalizedType.includes("kyc") ||
    normalizedType.includes("identity") ||
    normalizedType.includes("verification-request")
  ) {
    return "kyc";
  }
  if (
    normalizedType.includes("benefit") ||
    normalizedType.includes("enrollment") ||
    normalizedType.includes("subscription")
  ) {
    return "benefit";
  }
  if (normalizedType.includes("marketorder")) {
    return "marketOrder";
  }
  if (
    normalizedType.includes("attributes-corrections") ||
    normalizedType.includes("correction")
  ) {
    return "attributesCorrections";
  }
  if (
    normalizedType.includes("comment") ||
    normalizedType.includes("response")
  ) {
    return "task";
  }
  if (normalizedType.includes("escalat")) {
    return "escalation";
  }
  if (
    normalizedType.includes("employee") ||
    normalizedType.includes("invitation") ||
    normalizedType.includes("user") ||
    normalizedType.includes("profile")
  ) {
    return "employee";
  }
  return "general";
};

const IconComponent = {
  payment: Wallet,
  kyb: Stamp,
  kyc: Stamp,
  benefit: Banknote,
  employee: User,
  task: MessageCircle,
  marketOrder: Landmark,
  escalation: Hash,
  attributesCorrections: SquarePen,
  general: Bell,
} as const satisfies Record<NotificationCategory, typeof Wallet>;

export const NotificationItemIcon = ({
  type,
  category: categoryProp,
  isUnread,
}: Props) => {
  const category = categoryProp ?? getCategory(type);
  const Icon = IconComponent[category];

  return (
    <div className="relative">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-neutral-100 bg-neutral-50 group-hover:bg-white">
        <Icon className="h-6 w-6 flex items-center justify-center text-neutral-500" />
      </div>
      {isUnread && (
        <div className="absolute end-0 top-0 h-2 w-2 rounded-full bg-danger-500" />
      )}
    </div>
  );
};
